import { HP_IMPORTANT_TOOLS_FLAG } from 'clickNgo/entities/contact'
import { IContactFlag, IContactFlags } from 'clickNgo/entities/contactFlag'

import { FlagToReassign } from '../model/types'

const findFlag = (flag: IContactFlag) =>
  HP_IMPORTANT_TOOLS_FLAG.includes(flag.code) ||
  (flag.caption && HP_IMPORTANT_TOOLS_FLAG.includes(flag.caption))

export const getContactFlagsToReassign = (contactFlags: IContactFlags): FlagToReassign[] => {
  const userRights: FlagToReassign[] = contactFlags.UserRights.filter(findFlag).map((flag) => ({
    flag: flag,
  }))

  const campaigns: FlagToReassign[] = contactFlags.Campaigns.filter(findFlag).map((flag) => ({
    flag: flag,
  }))

  const tools: FlagToReassign[] = contactFlags.Tools.filter(findFlag).map((flag) => ({
    flag: flag,
  }))

  return [...userRights, ...campaigns, ...tools]
}
